import { CalendarDays } from 'lucide-react'
import { cn } from '@univdiam/ui/lib/utils'
import { dueDateClasses, getDueDateInfo } from '@univdiam/ui/lib/dueDate'

type DueDateChipProps = {
  value?: string | null
  /** Hide the calendar glyph where space is tight (kanban cards). */
  showIcon?: boolean
  className?: string
}

/**
 * Read-only counterpart to DueDatePicker, for list surfaces.
 *
 * Deliberately not interactive: on a kanban card it would sit inside a
 * draggable element whose whole surface opens the order, and a popover there
 * would fight both the drag handler and the row click. Editing stays in the
 * order header, where there is nothing to compete with.
 *
 * Renders nothing when no date is set -- an empty state per card is noise in a
 * list. Callers that need a placeholder supply their own.
 */
function DueDateChip({ value, showIcon = true, className }: DueDateChipProps) {
  const { bucket, label, tooltip } = getDueDateInfo(value)
  if (bucket === 'unset') return null

  return (
    <span
      title={tooltip}
      className={cn(
        'inline-flex w-fit shrink-0 items-center gap-1 rounded-[4px] border px-1.5 py-0.5 text-[11px] font-medium leading-none',
        dueDateClasses(bucket),
        className
      )}
    >
      {showIcon && <CalendarDays className="size-3 shrink-0" />}
      <span className="whitespace-nowrap">{label}</span>
    </span>
  )
}

export default DueDateChip
